import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api, getStoredUser, getToken, logout as doLogout, setStoredUser, setToken } from './api';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getStoredUser());
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = getToken();
    if (!t) { setReady(true); return; }
    api.get('/auth/me').then((r) => {
      setUser(r.data.user);
      setStoredUser(r.data.user);
    }).catch(() => {
      doLogout();
      setUser(null);
    }).finally(() => setReady(true));
  }, []);

  const loginWith = useCallback((token, userObj) => {
    setToken(token);
    setStoredUser(userObj);
    setUser(userObj);
  }, []);

  const refreshMe = useCallback(async () => {
    try {
      const r = await api.get('/auth/me');
      setUser(r.data.user);
      setStoredUser(r.data.user);
      return r.data.user;
    } catch {
      return null;
    }
  }, []);

  const logout = useCallback(() => {
    doLogout();
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, ready, loginWith, logout, refreshMe }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
